import {IFeatureLayerInfo} from '../../interfaces/models'

import {Feature} from '../../models'
import {parseFeatureFields} from '../../helpers'

export enum MapGridCell {
  None = 0,
  TopLeft = 11,
  TopCenter = 21,
  TopRight = 31,
  MiddleLeft = 12,
  MiddleCenter = 22,
  MiddleRight = 32,
  BottomLeft = 13,
  BottomCenter = 23,
  BottomRight = 33
}
export class MapPopupService {
  topHeightPercent: number
  centerHeightPercent: number

  topWidthPercent: number
  centerWidthPercent: number
  constructor(
    topHeightPercent: number = 40,
    centerHeightPercent: number = 20,
    topWidthPercent: number = 40,
    centerWidthPercent: number = 20
  ) {
    this.topHeightPercent = topHeightPercent
    this.centerHeightPercent = centerHeightPercent
    this.topWidthPercent = topWidthPercent
    this.centerWidthPercent = centerWidthPercent
  }

  public getDataPerLayer(data: {[id: string]: Array<Feature>}): number {
    let layerDataFound = 0
    for (const id in data) {
      if (data[id].length > 0) {
        layerDataFound++
      }
    }
    return layerDataFound
  }

  public getInfoDataPairs(data: {
    [id: string]: {features: Array<Feature>; layerInfo: IFeatureLayerInfo}
  }): Array<{featureLayerInfo: IFeatureLayerInfo; parsedFeature: {[label: string]: string}}> {
    const result: Array<{featureLayerInfo: IFeatureLayerInfo; parsedFeature: {[label: string]: string}}> = []
    for (const id in data) {
      const featureLayerInfo = data[id].layerInfo
      if (featureLayerInfo) {
        data[id].features.forEach(feature => {
          result.push({
            featureLayerInfo: featureLayerInfo,
            parsedFeature: parseFeatureFields(feature, featureLayerInfo)
          })
        })
      } else {
        console.warn(`No feature layer info found for ${id}`)
      }
    }
    return result
  }

  public getMapGridCell(
    pointPixelsHeight: number,
    pointPixelsWidth: number,
    mapWidth: number,
    mapHeight: number
  ): MapGridCell {
    if (pointPixelsHeight < 0 || pointPixelsHeight > mapHeight || pointPixelsWidth < 0 || pointPixelsWidth > mapWidth) {
      console.warn(`pixels ${pointPixelsHeight}, ${pointPixelsWidth} outside map extent`)
      return MapGridCell.None
    }

    const mapHeightUnit = mapHeight / 100
    let endOfTop = this.topHeightPercent * mapHeightUnit
    let endOfCenter = (this.topHeightPercent + this.centerHeightPercent) * mapHeightUnit
    let verticalLine = 0
    if (pointPixelsHeight > endOfCenter) {
      verticalLine = 3
    } else if (pointPixelsHeight > endOfTop) {
      verticalLine = 2
    } else {
      verticalLine = 1
    }

    const mapWidthUnit = mapWidth / 100
    endOfTop = this.topWidthPercent * mapWidthUnit
    endOfCenter = (this.topWidthPercent + this.centerWidthPercent) * mapWidthUnit
    let horizontalLine = 0
    if (pointPixelsWidth > endOfCenter) {
      horizontalLine = 30
    } else if (pointPixelsWidth > endOfTop) {
      horizontalLine = 20
    } else {
      horizontalLine = 10
    }

    return (MapGridCell as any)[(MapGridCell as any)[horizontalLine + verticalLine]]
  }
  public isThereEnoghtSpaceOnMap(
    mapWidth: number,
    mapHeight: number,
    mapPopupWidth: number,
    mapPopupHeight: number
  ): boolean {
    return mapHeight < mapPopupHeight * 2 || mapWidth < mapPopupWidth * 2
  }
}
